import { ArrowLeftOutlined } from '@ant-design/icons';
import { List } from '@refinedev/antd';
import { Space, Tabs } from 'antd';
import { useCallback, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useGetDetailCompany } from '../../../../../api/company';
import '../../../../styles/index.css';
import { DetailBank } from './detail-bank';
import DetailInfo from './detail-info';
import DetailWallet from './detail-wallet';

export const BeneficiariesDetail: React.FC<any> = ({isBeneficiariesRemitters = false}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get('tab');
  const [activeTab, setActiveTab] = useState<string>(
    (tab as string) || 'info'
  );

  const companyId = id ? Number(id) : null;
  const { data, isLoading } = useGetDetailCompany(companyId);

  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    if(isBeneficiariesRemitters) {
      navigate(`/beneficiaries-remitters/${id}?tab=${newTab}`, { replace: true });
    } else {
      navigate(`/customers/${id}/beneficiaries?tab=${newTab}`, { replace: true });
    }
  };

  const handleBack = useCallback(() => {
    if(isBeneficiariesRemitters) {
      navigate('/beneficiaries-remitters');
    } else {
      const userId = data?.data?.userId;
      navigate(`/customers/${userId}?tab=beneficiaries-remitters`);
    }
  }, [isBeneficiariesRemitters, navigate, data?.data?.userId]);
  
  const tabItems = [
    {
      key: 'info',
      label: 'Info',
      children: (
        <DetailInfo
          tabActive={activeTab as 'info' | 'bank' | 'wallet'}
          id={id}
          detailCompany={data?.data}
          isLoadingDetail={isLoading}
          handleChangeTab={handleTabChange}
          isActive={activeTab === 'info'}
          tabList={[
            {
              name: 'Add Wallets',
              value: 'wallet',
            },
            {
              name: 'Add Banks',
              value: 'bank',
            },
          ]}
        />
      ),
    },
    {
      key: 'wallet',
      label: 'Wallets',
      children: (
        <DetailWallet
          tabActive={activeTab as 'info' | 'bank' | 'wallet'}
          id={id}
          userId={data?.data?.userId || undefined}
          isActive={activeTab === 'wallet'}
        />
      ),
    },
    {
      key: 'bank',
      label: 'Banks',
      children: (
        <DetailBank
          tabActive={activeTab as 'info' | 'bank' | 'wallet'}
          id={id}
          userId={data?.data?.userId || undefined}
          isActive={activeTab === 'bank'}
        />
      ),
    },
  ];

  return (
    <List 
      title={
        <Space>
          <ArrowLeftOutlined 
            onClick={handleBack}
            className="back-icon"
          />
          <span>Beneficiary Details</span>
        </Space>
      }
    >
      <Tabs activeKey={activeTab} onChange={handleTabChange} items={tabItems} />
    </List>
  );
};

